





























































































































































import QuizBase from "@tt-app/components/exercise/QuizBase";
import { MicConfig, MicImplName } from "@joyz/app-core/utils/microphone";
import { api } from "@tt-app/api";
import { UserProfile, UserProfileAudioConfig } from "@tt-app/models";
import { PettEvaluation } from "@tt-app/models/internal/pett";
import { Course, Exercise } from "@tt-app/types";
import { detectSilence, getAuthInfo, uploadPronunciationDrillAudioToS3 } from "@tt-app/utils";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";
import { EXERCISE_TYPE, LOGGER_EVENTS, THRESOLD_PETT_ERROR_COUNT } from "@tt-app/constants";
import { logger } from "@tt-app/utils";

import AssignmentCompletionModal from "@tt-app/components/assignment/AssignmentCompletionModal.vue";
import LayoutExercise from "@tt-app/layouts/LayoutExercise.vue";
import ExerciseHeaderTitle from "@tt-app/components/exercise/ExerciseHeaderTitle.vue";
import TtMic from "@tt-app/components/exercise/TtMic.vue";
import SingleSentenceReadingQuestion from "@tt-app/components/exercise/SingleSentenceReading/SingleSentenceReadingQuestion.vue";
import SingleSentenceReadingReview from "@tt-app/components/exercise/SingleSentenceReading/SingleSentenceReadingReview.vue";
import SingleSentenceReadingTrophy from "@tt-app/components/exercise/SingleSentenceReading/SingleSentenceReadingTrophy.vue";
import SingleSentenceReadingToast from "@tt-app/components/exercise/SingleSentenceReading/SingleSentenceReadingToast.vue";
import SpeakerButton from "@tt-app/components/control/AudioPlaybackButton.vue";
import PracticeModeToast from "@tt-app/components/exercise/common/PracticeModeToast.vue";

import IconCheckbox from "@joyz/app-core/assets/icons/default/Checkbox.svg";
import IconCheckboxActive from "@joyz/app-core/assets/icons/active/Checkbox.svg";
import IconCheckboxActiveHovered from "@joyz/app-core/assets/icons/active/hovered/Checkbox.svg";
import FeedbackPopup from "@tt-app/components/feedback/FeedbackPopup.vue";
import {
  Session,
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";
import { audioContext } from "@tt-app/utils/audio/audioContext";

interface LogParameters {
  courseUuid: string;
  exerciseType: number;
  exerciseUuid: string;
  logId?: number;
  uuid: string;
}

interface Data {
  answerSubmitted: boolean;
  audioDecoderPlayer: AudioDecoderPlayer;
  audioProgress: number;
  chapter: any;
  course?: Course;
  currentPageIndex: number;
  evaluating: boolean;
  evaluations: {
    [key: string]: PettEvaluation;
  };
  exercise?: Exercise;
  exerciseType: number;
  feedbackFormVisible: boolean;
  hoveredIcon: boolean;
  icons: Record<string, any>;
  logId?: number;
  pettErrorCount: number;
  pettEvaluation?: PettEvaluation;
  pettEvaluationFailed: boolean;
  playingElement: any;
  practiceAgainUuids: string[];
  practiceMode: boolean;
  recording: boolean;
  recordingTimeout: number;
  recordingTimeoutFunction?: number;
  repetitions: number;
  section: any;
  sessionQuestionUuids: string[];
  showPracticeModeToast: boolean;
  showToast: boolean;
  silenceDetected: boolean;
  status: any;
  userAudio?: string;
  userAudioUrl?: string;
}

interface Methods {
  buttonMouseEnterHandler: () => void;
  buttonMouseLeaveHandler: () => void;
  collectiveCheckboxClickHandler: () => void;
  component: (componentConfig: any) => string;
  endExercise: () => void;
  evaluateAudio: (audioBlob: any) => void;
  handleFeedbackClose: () => void;
  incrementPage: () => void;
  logSSRResponse: () => void;
  onConnectionError: () => void;
  onMicStarted: () => void;
  onMicStopped: (audioBlob: any) => Promise<void>;
  onMicTimeout: () => void;
  onSilenceDetected: () => void;
  refreshAudioPlayer: () => void;
  resetData: (mic: any) => void;
  restartExerciseWithSelection: () => void;
  sentenceSelectionHandler: (problemUuid: string) => void;
  exampleAudioButtonClickHandler: (event: MouseEvent) => void;
  startAudioPlayback: (event: MouseEvent) => void;
  startExercise: () => void;
  stopAudioPlayback: () => void;
  timeUpdateHandler: (time: any) => void;
  tryAgain: () => void;
  uploadAudio: (audioBlob: Blob) => void;
}

interface Computed {
  audioConfig: UserProfileAudioConfig;
  numberOfAttempts: number;
  averageFluency: number;
  averageIntonation: number;
  averagePronunciation: number;
  averageTotal: number;
  body: any;
  buttonCheckboxIcon: string;
  currentPage: any;
  exerciseProgress: {
    current: number;
    total: number;
  };
  exerciseSentences: any;
  finalQuestion: boolean;
  header: any;
  isReview: boolean;
  isTrophy: boolean;
  limitedModeActive: boolean;
  logParameters: LogParameters;
  micConfig: MicConfig;
  micImplementation: MicImplName;
  nextExerciseButtonText: string;
  nextExerciseUuid?: string;
  practicePages: any;
  practiceSentences: any;
  nextButton: any;
  session: Session;
  showFeedbackForm: boolean;
  singleExampleAudio: boolean;
  totalFluency: number;
  totalIntonation: number;
  totalPronunciation: number;
  totalQuestions: number;
  trophyScores: any;
  userProfile: UserProfile;
  translation: string;
}

export default QuizBase.extend<Data, Methods, Computed>({
  name: "SingleSentenceReading",
  components: {
    AssignmentCompletionModal,
    FeedbackPopup,
    ExerciseHeaderTitle,
    LayoutExercise,
    PracticeModeToast,
    SpeakerButton,
    SingleSentenceReadingQuestion,
    SingleSentenceReadingReview,
    SingleSentenceReadingTrophy,
    SingleSentenceReadingToast,
    TtMic
  },
  data() {
    return {
      answers: {},
      allAttempts: {},
      answerSubmitted: false,
      audioDecoderPlayer: new AudioDecoderPlayer({ audioContext }),
      audioProgress: 0,
      chapter: undefined,
      course: undefined,
      currentPageIndex: 0,
      evaluating: false,
      evaluations: {},
      exercise: undefined,
      exerciseResult: undefined,
      exerciseType: EXERCISE_TYPE.SINGLE_SENTENCE_READING,
      feedbackFormVisible: true,
      hoveredIcon: false,
      icons: {
        active: {
          checkbox: IconCheckboxActive,
          hovered: {
            checkbox: IconCheckboxActiveHovered
          }
        },
        default: {
          checkbox: IconCheckbox
        }
      },
      logId: undefined,
      nav: {
        limitedModeUpdated: false,
        requireExitConfirmation: true
      },
      pettErrorCount: 0,
      pettEvaluation: undefined,
      pettEvaluationFailed: false,
      playingElement: undefined,
      practiceAgainUuids: [],
      practiceMode: false,
      recording: false,
      recordingTimeout: 30000,
      recordingTimeoutFunction: undefined,
      repetitions: -1,
      section: undefined,
      sessionQuestionUuids: [],
      showPracticeModeToast: false,
      showToast: false,
      silenceDetected: false,
      status: undefined,
      userAudio: undefined,
      userAudioUrl: undefined
    };
  },
  created() {
    document.addEventListener("visibilitychange", this.refreshAudioPlayer);
  },
  beforeDestroy() {
    window.clearTimeout(this.recordingTimeoutFunction);

    this.audioDecoderPlayer.destroy();

    document.removeEventListener("visibilitychange", this.refreshAudioPlayer);
  },
  computed: {
    audioConfig() {
      if (!this.userProfile) {
        return {
          accent: 0,
          speed: 100
        };
      }

      return this.userProfile.audio;
    },
    numberOfAttempts() {
      return Object.keys(this.allAttempts).length;
    },
    averageIntonation() {
      const average = this.totalIntonation / this.numberOfAttempts;
      const averageString = average === 100 ? average.toPrecision(3) : average.toPrecision(2);
      return Number(averageString);
    },
    averageFluency() {
      const average = this.totalFluency / this.numberOfAttempts;
      const averageString = average === 100 ? average.toPrecision(3) : average.toPrecision(2);
      return Number(averageString);
    },
    averagePronunciation() {
      const average = this.totalPronunciation / this.numberOfAttempts;
      const averageString = average === 100 ? average.toPrecision(3) : average.toPrecision(2);
      return Number(averageString);
    },
    averageTotal() {
      const total = (this.averageIntonation + this.averageFluency + this.averagePronunciation) / 3;
      const averageString = total === 100 ? total.toPrecision(3) : total.toPrecision(2);
      return Math.round(Number(averageString));
    },
    buttonCheckboxIcon() {
      if (this.practiceAgainUuids.length > 0) {
        if (this.hoveredIcon) {
          return this.icons.active.hovered.checkbox;
        }

        return this.icons.active.checkbox;
      }

      return this.icons.default.checkbox;
    },
    showFeedbackForm() {
      return this.feedbackFormVisible && this.isReview;
    },
    singleExampleAudio() {
      return typeof this.currentPage.body[0].audioFiles === "string";
    },
    totalFluency() {
      return Object.values(this.allAttempts).reduce<number>((total, currentAnswer: any) => {
        return total + (currentAnswer.scores?.fluency || 0);
      }, 0);
    },
    totalIntonation() {
      return Object.values(this.allAttempts).reduce<number>((total, currentAnswer: any) => {
        return total + (currentAnswer.scores?.intonation || 0);
      }, 0);
    },
    totalPronunciation() {
      return Object.values(this.allAttempts).reduce<number>((total, currentAnswer: any) => {
        return total + (currentAnswer.scores?.pronunciation || 0);
      }, 0);
    },
    trophyScores() {
      return {
        intonation: this.averageIntonation,
        fluency: this.averageFluency,
        pronunciation: this.averagePronunciation,
        total: this.averageTotal
      };
    },
    body() {
      if (!this.currentPage) {
        return undefined;
      }
      return this.currentPage.body;
    },
    currentPage() {
      if (!this.exercise) return;

      const allPages = this.exercise.pages;

      if (this.practiceMode) {
        return this.practicePages[this.currentPageIndex];
      }

      return allPages[this.currentPageIndex];
    },
    exerciseProgress() {
      return {
        current: this.currentPageIndex + 1,
        total: this.totalQuestions
      };
    },
    exerciseSentences() {
      if (!this.exercise) return;

      if (this.practiceMode) {
        return this.practiceSentences;
      }

      return this.exercise.pages.filter((page: any) => {
        return page.body[0].type === "SINGLE_SENTENCE_READING";
      });
    },
    finalQuestion() {
      if (!this.currentPage) {
        return false;
      }

      let nextPage;

      if (this.practiceMode) {
        nextPage = this.practicePages[this.currentPageIndex + 1];
      } else {
        nextPage = this.exercise.pages[this.currentPageIndex + 1];
      }

      return (
        nextPage && (nextPage.body[0].type === "SHOW_TROPHY" || nextPage.body[0].type === "REVIEW")
      );
    },
    header() {
      return {
        courseTitle: this.course?.title,
        chapterTitle: this.chapter?.title,
        exerciseTitle: this.exercise?.title,
        sectionTitle: this.section?.title
      };
    },
    isReview() {
      if (!this.currentPage) return false;
      return this.currentPage.body[0].type === "REVIEW";
    },
    isTrophy() {
      if (!this.currentPage) return false;
      return this.currentPage.body[0].type === "SHOW_TROPHY";
    },
    limitedModeActive() {
      return Boolean(this.session?.limitedMode?.id);
    },
    logParameters() {
      const problemUuid = this.currentPage.body[0].problemUuid;

      return {
        courseUuid: this.course.uuid,
        exerciseType: this.exercise.type,
        exerciseUuid: this.exercise.uuid,
        logId: this.logId,
        uuid: problemUuid
      };
    },
    micConfig() {
      return {
        impl: this.micImplementation,
        options: {
          audioCtx: audioContext,
          onRecordingStarted: this.onMicStarted,
          onRecordingStopped: this.onMicStopped,
          onSilenceDetected: () => this.onSilenceDetected(),
          queueIntervalPeriod: 1000
        }
      };
    },
    micImplementation() {
      // return this.$store.getters["user/micImplementation"];
      return "ScriptNodeRecorder";
    },
    nextButton() {
      return this.finalQuestion ? "exercise.action.review" : "exercise.next";
    },
    nextExerciseButtonText() {
      const i18nString = this.nextExercise ? "exercise.next" : "exercise.end";

      return this.$__(i18nString);
    },
    practicePages() {
      const filteredPages = this.exercise.pages.filter((page: any) => {
        if (page.body[0].type === "SHOW_TROPHY") {
          return false;
        }

        if (page.body[0].type !== "SINGLE_SENTENCE_READING") {
          return true;
        }

        if (this.sessionQuestionUuids.includes(page.body[0].problemUuid)) {
          return true;
        }

        return false;
      });

      return filteredPages;
    },
    practiceSentences() {
      if (this.isReview) {
        const answeredQuestionUuids = Object.keys(this.answers);

        return this.exercise.pages.filter((page: any) => {
          return (
            page.body[0].type === "SINGLE_SENTENCE_READING" &&
            answeredQuestionUuids.includes(page.body[0].problemUuid)
          );
        });
      }

      return this.exercise.pages.filter((page: any) => {
        return (
          page.body[0].type === "SINGLE_SENTENCE_READING" &&
          this.sessionQuestionUuids.includes(page.body[0].problemUuid)
        );
      });
    },
    session() {
      return this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.ACTIVE_SESSION}`
      ];
    },
    totalQuestions() {
      if (!this.exercise) return 0;

      if (this.practiceMode) {
        return this.practiceSentences.length;
      }

      return this.exerciseSentences.length;
    },
    userProfile() {
      return this.$store.state.user.profile;
    },
    translation() {
      if (!this.currentPage && !this.currentPage.body[0].translation) return "";
      return this.currentPage.body[0].translation;
    }
  },
  methods: {
    buttonMouseEnterHandler() {
      this.hoveredIcon = true;
    },
    buttonMouseLeaveHandler() {
      this.hoveredIcon = false;
    },
    collectiveCheckboxClickHandler() {
      if (this.practiceAgainUuids.length === this.exerciseSentences.length) {
        this.practiceAgainUuids = [];
        return;
      }

      this.practiceAgainUuids = this.exerciseSentences.map((sentence: any) => {
        return sentence.body[0].problemUuid;
      });
    },
    component(componentConfig) {
      const components = {
        REVIEW: "single-sentence-reading-review",
        SHOW_TROPHY: "single-sentence-reading-trophy",
        SINGLE_SENTENCE_READING: "single-sentence-reading-question"
      };

      const { type }: { type: "SINGLE_SENTENCE_READING" } = componentConfig;

      return components[type];
    },
    async endExercise() {
      const authInfo = await getAuthInfo(this.$store.getters);

      const payload = {
        courseUuid: this.course.uuid,
        exerciseType: this.exerciseType,
        exerciseUuid: this.exercise.uuid,
        logId: this.logId,
        totalScore: this.averageTotal
      };

      const params = {
        ...authInfo,
        ...payload
      };

      const response: any = await api.exercise.endSingleSentenceReadingExercise(params);

      this.exerciseResult = {
        ...response
      };

      this.nav.requireExitConfirmation = false;
    },
    async evaluateAudio(audioBlob) {
      this.evaluating = true;

      const sentence = this.currentPage.body[0].sentence;

      const response = await api.pett.sendForEvaluation(audioBlob[0], sentence);

      if (response.results) {
        this.pettEvaluation = response;

        const elements = this.pettEvaluation.results.elements;
        const phones = [...this.pettEvaluation.results.phones];

        const elementsWithPhones = elements.map((element: any) => {
          const splitArpa = element.composition.reduce((accumulator: any, composition: any) => {
            return [...accumulator, ...composition.arpa.split(" ")];
          }, []);

          const arpaLength = splitArpa.length;

          const arpaPhones = [];
          for (let i = 0; i < arpaLength; i++) {
            arpaPhones.push(phones.shift());
          }

          return {
            ...element,
            composition: [
              {
                ...element.composition[0],
                phones: arpaPhones
              }
            ]
          };
        });

        const evaluationWithPhonesInElements = {
          ...this.pettEvaluation,
          results: {
            ...this.pettEvaluation.results,
            elements: elementsWithPhones
          }
        };

        this.evaluations = {
          ...this.evaluations,
          [this.currentPage.body[0].problemUuid]: evaluationWithPhonesInElements
        };

        this.pettEvaluationFailed = false;
      } else {
        this.pettEvaluation = undefined;
        this.pettEvaluationFailed = true;
      }

      this.repetitions = this.repetitions + 1;
      this.evaluating = false;
    },
    handleFeedbackClose() {
      this.feedbackFormVisible = false;
    },
    incrementPage() {
      window.clearTimeout(this.recordingTimeoutFunction);

      if (this.$refs.container) {
        (this.$refs.container as HTMLElement).scrollTo({ top: 0, behavior: "smooth" });
      }

      this.repetitions = -1;
      this.status = undefined;
      this.pettEvaluationFailed = false;
      this.userAudio = undefined;
      /* @ts-ignore: calling the super component's method */
      QuizBase.options.methods.incrementPage.call(this);
    },
    async logSSRResponse() {
      this.answerSubmitted = true;

      if (this.pettEvaluationFailed && this.pettErrorCount < THRESOLD_PETT_ERROR_COUNT) {
        this.pettErrorCount += 1;
        this.userAudio = undefined;
      } else {
        const problemUuid = this.currentPage.body[0].problemUuid;

        const authInfo = await getAuthInfo(this.$store.getters);

        let settingsInfo = {};
        if (!this.singleExampleAudio) {
          settingsInfo = {
            accent: this.audioConfig.accent,
            speed: this.audioConfig.speed
          };
        }

        const params = {
          ...settingsInfo,
          audio: this.userAudioUrl,
          courseUuid: this.course.uuid,
          exerciseType: this.exerciseType,
          exerciseUuid: this.exercise.uuid,
          problemUuid,
          logId: this.logId!,
          pettFailed: this.pettEvaluationFailed,
          repeated: this.repetitions,
          evaluation: this.pettEvaluation
        };

        const payload = {
          ...authInfo,
          ...params
        };

        if (this.pettEvaluationFailed) {
          (params.pettFailed as boolean) = true;
          (params.evaluation as any) = undefined;
          this.pettErrorCount = 0;
        }

        const response: any = await api.exercise.submitAnswer(payload);

        this.status = response.isCorrect ? "correct" : "incorrect";

        const answer = {
          audio: this.userAudio,
          ...response
        };
        this.allAttempts = {
          ...this.allAttempts,
          [`${problemUuid}-${this.repetitions}`]: answer
        };

        this.answers = {
          ...this.answers,
          [problemUuid]: answer
        };
      }

      this.pettEvaluationFailed = false;
      this.answerSubmitted = false;
    },
    onConnectionError() {
      console.log("connection error");
    },
    onMicStarted() {
      const ttMic: any = this.$refs.microphone;
      const jzMic: any = ttMic.$refs.microphone;
      const micHandler = jzMic.mic;

      if (micHandler.errors.length > 0) {
        return;
      }

      this.stopAudioPlayback();

      const mic = this.$refs.microphone as any;

      this.recording = true;

      this.recordingTimeoutFunction = window.setTimeout(() => {
        if (mic) {
          mic.stopRecording();
        }
        this.$emit("recording-timeout");
      }, this.recordingTimeout);
    },
    async onMicStopped(audioBlob) {
      this.evaluating = true;
      const mic = this.$refs.microphone as any;

      window.clearTimeout(this.recordingTimeoutFunction);
      if (this.recording) {
        const firstBlob = audioBlob[0];

        const silenceDetected = await detectSilence(firstBlob);

        if (silenceDetected) {
          this.resetData(mic);
          this.recording = false;
          this.evaluating = false;
          this.onSilenceDetected();
          return;
        }

        this.userAudio = URL.createObjectURL(firstBlob);
        await this.uploadAudio(firstBlob);

        await this.evaluateAudio(audioBlob);

        await this.logSSRResponse();

        this.resetData(mic);
        this.recording = false;
      }
    },
    onMicTimeout() {
      console.log("mic timeout");
    },
    refreshAudioPlayer() {
      if (document.visibilityState === "visible") {
        console.log("refreshing audio player");
        this.audioDecoderPlayer = new AudioDecoderPlayer({ audioContext });
      }
    },
    resetData(mic) {
      (mic as any).resetData();
    },
    async restartExerciseWithSelection() {
      this.practiceMode = false;

      this.answers = {};
      this.answerSubmitted = false;
      this.currentPageIndex = 0;
      this.exerciseResult = undefined;
      this.review = {};
      this.nav.requireExitConfirmation = true;
      this.sessionQuestionUuids = this.practiceAgainUuids;

      const authInfo = await getAuthInfo(this.$store.getters);
      const details = {
        assignmentId: Number(this.assignmentId) || undefined,
        courseUuid: this.$route.params.courseUuid,
        exerciseUuid: this.$route.params.exerciseUuid,
        exerciseType: this.exerciseType,
        problemUuids: this.practiceAgainUuids
      };

      const apiPayload = { ...authInfo, ...details };

      const response: any = await api.exercise.startExercise(apiPayload);
      this.logId = response.logId;

      this.practiceAgainUuids = [];
      this.practiceMode = true;
      this.feedbackFormVisible = true;
    },
    sentenceSelectionHandler(problemUuid) {
      if (this.practiceAgainUuids.includes(problemUuid)) {
        this.practiceAgainUuids = this.practiceAgainUuids.filter(practiceAgainUuid => {
          return practiceAgainUuid !== problemUuid;
        });
      } else {
        this.practiceAgainUuids = [...this.practiceAgainUuids, problemUuid];
      }
    },
    onSilenceDetected() {
      this.silenceDetected = true;
    },
    exampleAudioButtonClickHandler(event) {
      if (this.playingElement) {
        this.stopAudioPlayback();
      }

      this.startAudioPlayback(event);
    },
    async startAudioPlayback(event) {
      this.playingElement = event.currentTarget;

      const audioUrl = this.playingElement.getAttribute("src");
      const fallbackUrl = this.playingElement.getAttribute("src-fallback");

      if (this.audioDecoderPlayer.status === "playing") {
        this.audioDecoderPlayer.stop();
      }

      logger.logEvent(LOGGER_EVENTS.USER.EXAMPLE_AUDIO_PLAY_PRESS.SUCCESS, {
        ...this.logParameters,
        url: audioUrl
      });

      await audioContext.resume();
      await this.audioDecoderPlayer.play([audioUrl], {
        onEnded: () => {
          this.stopAudioPlayback();

          logger.logEvent(LOGGER_EVENTS.APPLICATION.EXAMPLE_AUDIO_PLAY.SUCCESS, {
            ...this.logParameters,
            url: audioUrl
          });
        },
        onError: error => {
          logger.logEvent(LOGGER_EVENTS.APPLICATION.EXAMPLE_AUDIO_PLAY.FAILURE, {
            ...this.logParameters,
            url: audioUrl,
            error: error.error
          });

          if (fallbackUrl) {
            this.audioDecoderPlayer.play([fallbackUrl], {
              onEnded: () => {
                this.stopAudioPlayback();

                logger.logEvent(LOGGER_EVENTS.APPLICATION.EXAMPLE_AUDIO_PLAY.SUCCESS, {
                  ...this.logParameters,
                  url: fallbackUrl
                });
              },
              onError: secondError => {
                logger.logEvent(LOGGER_EVENTS.APPLICATION.EXAMPLE_AUDIO_PLAY.FAILURE, {
                  ...this.logParameters,
                  url: fallbackUrl,
                  error: secondError.error
                });
              }
            });
          }
        }
      });
    },
    async startExercise() {
      const authInfo = await getAuthInfo(this.$store.getters);
      const details = {
        assignmentId: Number(this.assignmentId) || undefined,
        courseUuid: this.$route.params.courseUuid,
        exerciseUuid: this.$route.params.exerciseUuid,
        exerciseType: this.exerciseType,
        limitedModeId: this.session?.limitedMode?.id,
        sessionId: this.session?.id
      };

      const apiPayload = { ...authInfo, ...details };

      const response: any = await api.exercise.startExercise(apiPayload);

      this.logId = response.logId;
      this.nav.requireExitConfirmation = true;
    },
    stopAudioPlayback() {
      if (this.audioDecoderPlayer.status === "playing") {
        this.audioDecoderPlayer.stop();
      }
    },
    timeUpdateHandler(event) {
      this.audioProgress = (event.target.currentTime / event.target.duration) * 100;
    },
    tryAgain() {
      this.status = undefined;
      this.userAudio = undefined;
    },
    async uploadAudio(firstBlob) {
      this.userAudioUrl = await uploadPronunciationDrillAudioToS3(firstBlob);
    }
  },
  watch: {
    repetitions(newValue) {
      if (newValue === 3) {
        this.showToast = true;

        window.setTimeout(() => {
          this.showToast = false;
        }, 5000);
      }
    },
    currentPage(newValue) {
      const isTrophyPage = newValue.body[0].type === "SHOW_TROPHY";

      const isReview = newValue.body[0].type === "REVIEW";

      if (this.practiceMode && isReview) {
        this.endExercise();
      }

      if (isTrophyPage) {
        this.endExercise();
      }
    },
    exercise() {
      this.startExercise();
    },
    practiceMode() {
      this.showPracticeModeToast = true;

      window.setTimeout(() => {
        this.showPracticeModeToast = false;
      }, 5000);
    }
  }
});
